import { render, staticRenderFns } from "./RoleDrawerSimpleSwitch.vue?vue&type=template&id=2443f0f4&scoped=true&"
import script from "./RoleDrawerSimpleSwitch.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerSimpleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./RoleDrawerSimpleSwitch.vue?vue&type=style&index=0&id=2443f0f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2443f0f4",
  null
  
)

export default component.exports